/**
 * @name debounce
 *
 * @description Debounce a function by a given time in milliseconds
 *
 * @example
 * import { debounce } from '@workbench/core';
 *
 * const debouncedFn = debounce(fn, 300);
 */
export const debounce = (fn: (...args: Array<unknown>) => unknown, milliseconds: number): ((...args: Array<unknown>) => void) => {
  let scheduled = null;

  return (...args) => {
    clearTimeout(scheduled);
    scheduled = setTimeout(() => fn(...args), milliseconds, ...args);
  };
};
